import { gql, useMutation } from '@apollo/client';

import { OdProtosListingsData_NoteType } from '../../../__generated__/athenaGlobalTypes';
import { SetNote, SetNoteVariables } from '../../../graphql/athena/mutations/__generated__/SetNote';
import { LWC_DETAILS_QUERY } from '../../../graphql/athena/queries/LwcDetails';
import { LWC_DETAILS_FOR_BROKERAGE_QUERY } from '../queries/BrokerageLwcDetails';

export const SET_NOTE = gql`
  mutation SetNote(
    $lwcProductId: String!
    $noteContent: String!
    $noteType: OdProtosListingsData_NoteType!
  ) {
    odProtosListingsServicesListwithcertaintyproduct {
      setNote(input: { lwcProductId: $lwcProductId, note: $noteContent, type: $noteType }) {
        _empty
      }
    }
  }
`;

/**
 * Allows the setting of note details on a listing
 * The different note types are agent, cep, and passback notes
 */
export const useSetNote = () => {
  const [updateSetNote, { data, error, loading }] = useMutation<SetNote, SetNoteVariables>(
    SET_NOTE,
    {
      fetchPolicy: 'no-cache',
      context: {
        clientName: 'athena',
      },
      refetchQueries: [LWC_DETAILS_QUERY, LWC_DETAILS_FOR_BROKERAGE_QUERY],
    },
  );

  const setNote = (lwcProductId: string, note: string, type: OdProtosListingsData_NoteType) =>
    updateSetNote({
      variables: { lwcProductId, noteContent: note, noteType: type },
    });
  return { setNote, data, loading, error };
};
